<template>
  <div class="financeEntry">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div
        :class="!isToggle ? 'list-container' : ''"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="checkBox" v-if="isToggle">
          <checkbox
            v-model="item.isSelected"
            :disabled="item.disabled"
            @input="handleCheckBox"
          ></checkbox>
        </div>
        <div :class="isToggle ? 'checkBox-container' : ''">
          <div class="list-item">
            {{ $t.clientFund.inquiryNumber }}：{{ item.PaymentInquiryNumber }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.paymentTradeNumber }}：{{ item.PaymentTradeNumber }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.receiveDate }}：{{ item.FillInOrReceiveDate }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.fundClass }}：
            <span v-if="item.PaymentType == 1">{{ $t.clientFund.paymentType1 }}</span>
            <span v-if="item.PaymentType == 2">{{ $t.clientFund.paymentType2 }}</span>
          </div>
          <div class="list-item">
            {{ $t.clientFund.accountName }}：{{ item.AccountName }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.bankAccount }}：{{ item.AccountNickName }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.remitterName }}：{{ item.RemitterName }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.remittanceLocation }}：{{ item.RemittanceLocation }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.receivedAmount }}：{{ item.ReceivedAmount }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.receivedCurrency }}：{{ item.ReceivedCurrencyStr }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.entryState }}：
            <span v-if="item.EntryState == 0">{{ $t.clientFund.entryState1 }}</span>
            <span v-if="item.EntryState == 1">{{ $t.clientFund.entryState2 }}</span>
            <span v-if="item.EntryState == 2">{{ $t.clientFund.entryState3 }}</span>
          </div>
          <div class="list-item">{{ $t.clientFund.agent }}：{{ item.UserName }}</div>
          <div class="list-item">
            {{ $t.clientFund.serialRegistrationNumber }}：{{
              item.SerialRegistrationNumber
            }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.fundsTransferCustomerNumber }}：{{
              item.FundsTransferCustomerNumber
            }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.fundsTransferCustomerName }}：{{
              item.FundsTransferCustomerName
            }}
          </div>
          <div class="list-item">
            {{ $t.clientFund.transferUserName }}：{{ item.TransferUserName }}
          </div>
          <div class="buttons">
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="dialogShow(item.CEId)"
              v-if="item.FileCount"
              >{{ $t.clientFund.entryFile }}</van-button
            >
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="gotoDetail(item.CEId)"
              >{{ $t.meta.editButton }}</van-button
            >
            <van-button
              class="danger-btn"
              size="small"
              type="primary"
              @click="dialogDeleteShow(item.CEId)"
              v-if="item.EntryState == 0"
            >
              {{ $t.meta.delete }}
            </van-button>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.clientFund.fundClass }}</div>
        <van-radio-group v-model="paymentType" direction="horizontal">
          <van-radio :name="1">{{ $t.clientFund.paymentType1 }}</van-radio>
          <van-radio :name="2">{{ $t.clientFund.paymentType2 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.clientFund.entryState }}</div>
        <van-radio-group v-model="entryState" direction="horizontal">
          <van-radio :name="0">{{ $t.clientFund.entryState1 }}</van-radio>
          <van-radio :name="1">{{ $t.clientFund.entryState2 }}</van-radio>
          <van-radio :name="2">{{ $t.clientFund.entryState3 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.currency }}</div>
        <van-radio-group v-model="currency" direction="horizontal">
          <van-radio
            :name="currency.SCId"
            v-for="(currency, index) in currencyList"
            :key="index"
            >{{ currency.CurrencySn }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.clientFund.amountStatistics }}</div>
        <van-radio-group v-model="amountStatistics" direction="horizontal">
          <van-radio :name="0">{{ $t.clientFund.remittanceAmount }}</van-radio>
          <van-radio :name="1">{{ $t.clientFund.bankCharges }}</van-radio>
          <van-radio :name="2">{{ $t.clientFund.receivedAmount }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.clientFund.dateStatistics }}</div>
        <van-radio-group v-model="dateStatistics" direction="horizontal">
          <van-radio :name="1">{{ $t.clientFund.receiveDate }}</van-radio>
          <van-radio :name="2">{{ $t.clientFund.createTime }}</van-radio>
        </van-radio-group>

        <van-field
          v-model="selectedAccount.text"
          :label="$t.clientFund.bankAccount"
          @click="pickerShow('showAccountPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
        />

        <van-field
          v-model="minAmount"
          :label="$t.clientFund.minAmount"
          :placeholder="$t.meta.input"
          clickable
        />

        <van-field
          v-model="maxAmount"
          :label="$t.clientFund.maxAmount"
          :placeholder="$t.meta.input"
          clickable
        />

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showAccountPicker" round position="bottom">
      <van-picker
        :label="$t.clientFund.bankAccount"
        show-toolbar
        :columns="accountInfoList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="accountConfirm"
        @cancel="showAccountPicker = false"
      />
    </van-popup>

    <van-dialog
      :title="$t.clientFund.entryFile"
      width="90%"
      v-model="dialogVisible"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
    >
      <slot name="default">
        <div class="financeEntry-alert">
          <van-form label-width="120px">
            <div class="multi-table" v-if="entryFileList">
              <div v-for="(item, index) in entryFileList" :key="index">
                <van-field :label="'No.' + (index + 1)">
                  <template #input>
                    <van-image
                      :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                      @click="imagePreview(imgUrlFilter(item.FileAddress))"
                      width="50"
                      height="50"
                      fit="contain"
                      style="vertical-align: top"
                      v-if="item.FileAddress"
                    ></van-image>
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteCustomerCapitalEntry"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <van-dialog
      :title="$t.clientFund.transfer1"
      width="90%"
      v-model="dialogTransferVisible"
      @cancel="dialogTransferVisible = false"
      @confirm="dialogTransferSubmit"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="financeEntry-alert">
          <van-form label-width="120px">
            <van-field
              v-model="dialogContent.AccountIdStr"
              :label="$t.clientFund.bankAccount"
              readonly
            />

            <van-field
              v-model="dialogContent.RemitterName"
              :label="$t.clientFund.remitterName"
              readonly
            />

            <van-field
              v-model="dialogContent.ReceivedAmount"
              :label="$t.clientFund.receivedAmount"
              readonly
            />

            <van-field
              v-model="dialogContent.ReceivedCurrencyStr"
              :label="$t.clientFund.remittanceCurrency"
              readonly
            />

            <div class="alert-ties">
              {{ $t.clientFund.customerNotice }}
            </div>

            <van-field
              clickable
              readonly
              required
              :label="$t.clientFund.customer"
              :value="dialogForm.Customer.text"
              type="textarea"
              rows="3"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showFinanceEntryUser')"
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <fetch-list
      event="showFinanceEntryUser"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <div v-if="isToggle">
        <van-button type="info" class="entry-button" @click="actionSelection"
          ><span v-if="selectedEntry">{{ selectedEntry.PaymentInquiryNumber }}</span
          ><span v-else>{{ $t.clientFund.clickNotice }}</span></van-button
        >
        <van-button type="info" class="confirm-button" @click="dialogTransferShow">
          {{ $t.clientFund.transfer2 }}</van-button
        >
        <van-button class="cancel-button" @click="cancelMode">
          {{ $t.clientFund.transfer3 }}</van-button
        >
      </div>
      <div v-else>
        <van-button type="info" block @click="handleSheetShow">{{
          $t.meta.menu
        }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
  Image,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Image);

import Selection from "@/views/main/financialManagement/clientFund/selection/index.js";
import Checkbox from "@components/checkbox/Checkbox.vue";
import FetchList from "@components/fetchList/FetchList.vue";

export default {
  name: "financeEntry",
  components: {
    Checkbox,
    FetchList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      accountInfoList: [],
      currencyList: [],
      //入账文件
      dialogVisible: false,
      entryFileList: [],
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.clientFund.remitterName,
          value: 1,
        },
        {
          text: this.$t.clientFund.inquiryNumber,
          value: 2,
        },
      ],
      currency: null,
      paymentType: null,
      entryState: 0,
      amountStatistics: null,
      dateStatistics: null,
      selectedAccount: { text: "", value: null },
      minAmount: "",
      maxAmount: "",
      showFilter: false,
      showAccountPicker: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //delete
      dialogDeleteId: "",
      showDeleteDialog: false,
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      isToggle: false,
      //客资归账
      selectedEntry: null,
      dialogTransferVisible: false,
      dialogContent: {},
      dialogForm: {
        Customer: { value: "" },
        BusinessEntryList: [],
        FinanceEntryList: [],
      },
    };
  },
  created() {
    this.getCurrencyList();
    this.getCollectionAccountInfoList();
  },
  methods: {
    onSelectCustomer(item) {
      this.dialogForm.Customer.text = item.text;
      this.dialogForm.Customer.value = item.value;
    },
    dialogTransferSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        BusinessEntryList: this.dialogForm.BusinessEntryList,
        FinanceEntryList: this.dialogForm.FinanceEntryList,
        CustomerId: this.dialogForm.Customer.value,
      };
      this.$api.financialManagement
        .addCustomerCapitalTransfer(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogTransferVisible = false;
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleCheckBox() {
      var items = this.tableData.filter((p) => p.isSelected);
      for (var item of this.tableData) {
        if (items.length > 0) {
          if (item.isSelected) {
            this.dialogForm.FinanceEntryList = [item.CEId];
            item.disabled = false;
          } else {
            item.disabled = true;
          }
        } else {
          this.dialogForm.FinanceEntryList = [];
          item.disabled = false;
        }
      }
    },
    getTransferInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          BusinessEntryList: this.dialogForm.BusinessEntryList,
          FinanceEntryList: this.dialogForm.FinanceEntryList,
        };
        this.$api.financialManagement
          .loadCustomerCapitalTransferInfo(param)
          .then((res) => {
            this.dialogContent = res.data;
            //银行账户
            this.dialogContent.AccountId = res.data.AccountId.toString();
            var account = this.accountInfoList.find(
              (c) => c.value == this.dialogContent.AccountId
            );
            if (account) {
              this.dialogContent.AccountIdStr = account.text;
            }
            //入账客户
            this.dialogForm.Customer = {
              text: this.dialogContent.CustomerName,
              value: this.dialogContent.CustomerId,
            };
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    dialogTransferShow() {
      if (this.dialogForm.BusinessEntryList.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.clientFund.selectBill1,
          type: "danger",
        });
        return;
      }
      if (this.dialogForm.FinanceEntryList.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.clientFund.selectBill2,
          type: "danger",
        });
        return;
      }
      this.getTransferInfo().then((success) => {
        if (success) {
          this.dialogTransferVisible = true;
        }
      });
    },
    actionSelection() {
      const selection = Selection();
      selection.onSelected = (data) => {
        this.selectedEntry = data;
        this.dialogForm.BusinessEntryList = [data.CEId];
      };
      selection.show();
    },
    cancelMode() {
      this.isToggle = false;
      this.entryState = 0;
      this.selectedEntry = null;
      this.filterReset();
    },
    toggleMode() {
      this.isToggle = true;
      this.entryState = 0;
      this.filterReset();
    },
    sheetSelect(e) {
      if (e.className == "1") {
        this.gotoDetail(null);
      }
      if (e.className == "2") {
        this.toggleMode();
      }
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.clientFund.financeAddButton, className: "1" },
        { name: this.$t.clientFund.transfer1, className: "2" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    deleteCustomerCapitalEntry() {
      this.$commonMethod.showLoading();
      var param = {
        CEId: this.dialogDeleteId,
      };
      this.$api.financialManagement
        .deleteCustomerCapitalEntry(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "financeEntryDetail",
        name: "financeEntryDetail",
        query: [
          {
            name: "CEId",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.paymentType ||
        this.entryState ||
        this.currency ||
        this.amountStatistics ||
        this.dateStatistics ||
        this.selectedAccount.value ||
        this.minAmount ||
        this.maxAmount ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.paymentType = null;
      this.entryState = 0;
      this.currency = null;
      this.amountStatistics = null;
      this.dateStatistics = null;
      this.selectedAccount = { text: "", value: null };
      this.minAmount = "";
      this.maxAmount = "";
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        PaymentType: this.paymentType,
        EntryState: this.entryState,
        AccountId: this.selectedAccount.value,
        RemitterName: this.searchType == 1 ? this.searchText : "",
        PaymentInquiryNumber: this.searchType == 2 ? this.searchText : "",
        SCId: this.currency,
        AmountStatistics: this.amountStatistics,
        MinAmount: this.minAmount,
        MaxAmount: this.maxAmount,
        DateStatistics: this.dateStatistics,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.financialManagement
        .getCustomerCapitalFinanceEntryList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    dialogShow(id) {
      this.getCustomerCapitalEntryFileListByCEId(id).then((success) => {
        if (success) this.dialogVisible = true;
      });
    },
    getCustomerCapitalEntryFileListByCEId(id) {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          CEId: id,
        };
        this.$api.financialManagement
          .getCustomerCapitalEntryFileListByCEId(param)
          .then((res) => {
            this.entryFileList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    accountConfirm(e) {
      this.selectedAccount.text = e.text;
      this.selectedAccount.value = e.value;
      this.showAccountPicker = false;
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            this.currencyList = res.data;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCollectionAccountInfoList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getCollectionAccountInfoList({
            CompanyId: this.CompanyId,
            IsEnable: 1,
            PageIndex: 0,
            PageSize: 1000,
          })
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.AccountNickName,
                value: item.AccountId,
              };
              result.push(data);
            });
            this.accountInfoList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.financeEntry {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .checkBox {
      vertical-align: middle;
      display: inline-block;
      margin: 15px;
    }
    .checkBox-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
    }
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
    }
    .list-item {
      margin-bottom: 10px;
    }
    .list-item:last-child {
      margin-bottom: 0px;
    }
    .buttons {
      text-align: right;
      .primary-btn {
        margin-top: 5px;
        margin-left: 5px;
        border-radius: 5px;
        background: $-color-primary;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .default-btn {
        margin-top: 5px;
        margin-left: 5px;
        border-radius: 5px;
        background: $-color-light-gray;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .search-btn {
        margin-top: 5px;
        margin-left: 5px;
        border-radius: 5px;
        background: $-color-green;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .warning-btn {
        margin-top: 5px;
        margin-left: 5px;
        border-radius: 5px;
        background: #ffba00;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .danger-btn {
        margin-top: 5px;
        margin-left: 5px;
        border-radius: 5px;
        background: $-color-red;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .financeEntry-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
    .alert-ties {
      font-size: 12px;
      padding: 15px;
      color: #999;
      border-bottom: 1px solid #ebedf0;
    }
    .multi-table {
      .multi-table-header {
        background: #ffffff;
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
    .entry-button {
      border: none;
      background: #fffbe8;
      color: #ed6a0c;
      display: inline-block;
      width: 100%;
    }
    .cancel-button {
      border: none;
      display: inline-block;
      width: 50%;
    }
    .confirm-button {
      border: none;
      display: inline-block;
      width: 50%;
    }
  }
}
</style>
